import type { QueryKey } from '@tanstack/react-query';
import { createContext, useContext } from 'react';

import type { WorkTaskAutomationRecommendation } from '../../../data-contract/task-management';

/**
 * Where a task's automation recommendation is read from. Without one the work task endpoint is read, behind the
 * recipes flag; a surface that reads tasks through its own scope, such as the position alignment, provides its own.
 */
export type AutomationRecommendationSource = {
    readonly fetchRecommendation: (input: {
        readonly signal: AbortSignal;
        readonly taskId: string;
    }) => Promise<WorkTaskAutomationRecommendation>;
    readonly isEnabled: boolean;
    readonly queryKey: (taskId: string) => QueryKey;
};

const AutomationRecommendationSourceContext = createContext<AutomationRecommendationSource | null>(null);

export const AutomationRecommendationSourceProvider = AutomationRecommendationSourceContext.Provider;

export const useAutomationRecommendationSource = (): AutomationRecommendationSource | null =>
    useContext(AutomationRecommendationSourceContext);
